import { Pressable as TouchableOpacity } from "react-native";
import BottomButton from "./BottomButton";

export { BottomButton, TouchableOpacity };
